import { ReactNode } from 'react';
import AppHeader from '@/components/Elements/Header/AppHeader';

interface Props {
  children: ReactNode;
  title?: string;
  registeredStatus?: string;
  backButton?: boolean;
  noMyPage?: boolean;
  handleBack?: () => void;
  linkToMypage?: () => void; // feature/reservation と feature/myPage から呼ばれておりこのpropsはfeature/myPageのためのもの
}

function Layout({
  children,
  title,
  registeredStatus,
  backButton = false,
  noMyPage = false,
  handleBack,
  linkToMypage
}: Props) {
  return (
    <>
      <AppHeader
        title={title}
        registeredStatus={registeredStatus}
        showBackButton={backButton}
        handleBack={handleBack}
        handleTop={linkToMypage}
        noMyPage={noMyPage}
      />
      {children}
    </>
  );
}
export default Layout;
